import {EnvSetup} from "enums/Envs";
import {request} from "services/request";
import {
    PhotoPayloadBloom,
    PhotoPayloadFlava,
    PhotoPayloadInstinct,
    PhotoPayloadSpark,
    toBloomPhotoPayload,
    toDate
} from "services/payloads";


interface BlackListUserServer {
    createdDate: string,
    faceSimilarUserCount: number,
    hashSimilarUserCount: number,
    name: string,
    photos: PhotoPayloadBloom[] | PhotoPayloadInstinct[] | PhotoPayloadFlava[] | PhotoPayloadSpark[]
    userKey: string
}

export interface BlackListUser {
    createdDate?: Date,
    faceSimilarUserCount: number,
    hashSimilarUserCount: number,
    name: string,
    photos: PhotoPayloadBloom[]
    userKey: string
}


export const blackListService = {
    getAll: async (
        env: EnvSetup
    ) => {
        const response = await request<{
            users?: BlackListUserServer[],
            profiles?: BlackListUserServer[],
            sparkers?: BlackListUserServer[]
        }>({
            url: `black-list`,
            method: 'get',
        });
        return (response?.users ?? response?.profiles ?? response?.sparkers)?.map(u => ({
            ...u,
            createdDate: toDate(u.createdDate, env.app),
            photos: u.photos?.map(p => toBloomPhotoPayload(p)) ?? []
        }) as BlackListUser) ?? [];
    },
    add: async (
        env: EnvSetup,
        {name, files}: { name: string; files: File[] }
    ) => {
        const formData = new FormData();
        formData.append("request", JSON.stringify({name}));
        files.forEach((file) => {
            formData.append("files", file); // No file.name or blob wrapping
        });

        const response = await request<{ users: BlackListUser[] }>({
            url: "black-list",
            method: "post",
            data: formData,
        });

        return response?.users;
    },
    addPhotos: async (
        env: EnvSetup,
        {key, files}: { key: string; files: File[] }
    ) => {
        const formData = new FormData();
        files.forEach(f => formData.append("file", f, f.name));

        const response = await request<{ users: BlackListUser[] }>({
            url: `black-list/${key}/photos`,
            method: "post",
            data: formData,
        });

        return response?.users;
    },
    delete: async (
        env: EnvSetup,
        id: string
    ) => {
        const response = await request({
            url: `black-list/${id}`,
            method: 'delete',
        });
        return response;
    }
}